/** WP-M's notification centre — NT1 at `/notifications`. */
import type { RouteObject } from 'react-router-dom';
import { NT1Notifications } from './NT1Notifications.js';

export const notificationRoutes: RouteObject[] = [
  { path: '/notifications', element: <NT1Notifications /> },
];

export { NT1Notifications, NT1NotificationsView } from './NT1Notifications.js';
export { NotificationBell } from './bell.js';
// `./data.js` is gone. NT1 renders `GET /v1/notifications`, and the strings that used to
// live there — the title, the action, the three tabs, the footer — are served with the
// rows (`apps/api/src/notifications/screens.ts`). A screen that holds its own Bangla
// eventually holds a different Bangla from the row beside it.
export * from './api.js';
export * from './types.js';
